"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapValues(object, iteratee) {
  var result = {};

  for (var key in object) {
    if ({}.hasOwnProperty.call(object, key)) {
      result[key] = iteratee(object[key], key, object);
    }
  }

  return result;
}

exports.default = mapValues;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-form/lib/utils/map-values.js
 ** module id = 575
 ** module chunks = 0 1
 **/